import React, { useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveTab } from '../../redux/slice/game.slice';
import { Flame, Star, ShoppingCart, Zap } from 'lucide-react';

const TABS = [
  { name: 'Trending', label: 'TRENDING NOW', icon: Flame },
  { name: 'New Releases', label: 'NEW RELEASES', icon: Star },
  { name: 'Top Selling', label: 'TOP SELLING', icon: ShoppingCart },
  { name: 'Most Played', label: 'MOST PLAYED', icon: Zap },
];

export default function TrendingTabs() {
  const dispatch = useDispatch();
  const { activeTab } = useSelector((s) => s.game);
  const containerRef = useRef(null);
  const activeTabRef = useRef(null);

  const handleTabClick = (e, tabName) => {
    dispatch(setActiveTab(tabName));
    if (e?.currentTarget) {
      e.currentTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  };

  return (
    <div className="w-full max-w-full overflow-hidden flex justify-center">
      <div
        ref={containerRef}
        data-lenis-prevent
        className="p-1.5 sm:p-2 rounded-2xl bg-[#080b16]/95 backdrop-blur-xl border border-white/[0.1] shadow-[0_10px_30px_rgba(0,0,0,0.6)] flex items-center gap-2 sm:gap-2.5 overflow-x-auto no-scrollbar scroll-smooth touch-pan-x overscroll-x-contain select-none max-w-full"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {TABS.map((tab) => {
          const isActive = activeTab === tab.name;
          const Icon = tab.icon;

          return (
            <button
              key={tab.name}
              ref={isActive ? activeTabRef : null}
              type="button"
              onClick={(e) => handleTabClick(e, tab.name)}
              className={`flex-shrink-0 min-w-max flex items-center gap-2 sm:gap-2.5 px-3.5 sm:px-5 py-2 sm:py-2.5 rounded-xl sm:rounded-2xl text-xs font-cyber font-bold tracking-wider uppercase relative cursor-pointer border transition-[transform,box-shadow,border-color] duration-150 group ${isActive
                ? 'bg-gradient-to-r from-[#00e5ff] via-[#5c60ff] to-[#bd00ff] bg-no-repeat bg-[length:100%_100%] border-transparent text-black shadow-[0_4px_20px_rgba(92,96,255,0.35)]'
                : 'bg-[#0a0d18]/80 border-white/[0.08] text-gray-300 hover:text-white hover:border-white/25 hover:bg-[#12172a]'
                }`}
            >
              <Icon
                className={`w-3.5 h-3.5 sm:w-4 sm:h-4 transition-transform duration-150 group-hover:scale-110 ${isActive ? 'text-black stroke-[2.2]' : 'text-gray-400 group-hover:text-white'
                  }`}
              />
              <span className="whitespace-nowrap tracking-wider">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
